import React from "react";
// -------------------------------------------------------------
import { getAgingData } from "Redux/data/actions";
import { useAnalysis, useScenarioFlag } from "Redux/data/hooks";
import {
  Area,
  XAxis,
  YAxis,
  ComposedChart,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Line,
} from "recharts";

// -------------------------------------------------------------
// -------------------------------------------------------------
const Aging = () => {
  const { data: aging } = useAnalysis("aging", getAgingData);
  const hasMaster = useScenarioFlag("hasMaster");
  if (!hasMaster)
    return (
      <div className="notification is-warning is-light">
        No master frame has been built yet.
      </div>
    );

  if (!aging) return null;

  const chartData = [...aging.data].reverse().map((item) => {
    return {
      date: item["Reference Date"],
      current: -item["Current"],
      bucket_a: -item["One_Thirty"],
      total: -item["Total"],
    };
  });

  console.log(chartData);
  // Calculate the minimum current value
  const minCurrent = Math.min(...chartData.map((item) => item.current));

  return (
    <div style={{ height: "500px", width: "100%" }}>
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart
          width={500}
          height={400}
          data={chartData}
          margin={{
            top: 10,
            right: 35,
            left: 35,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis
            domain={[0.8*minCurrent, "auto"]}
            scale="linear"
            allowDataOverflow={true}
            type="number"
          />
          <Tooltip />
          <Area
            type="monotone"
            dataKey="current"
            stackId="3"
            stroke="#8884d8"
            fill="#8884d8"
          />
          <Area
            type="monotone"
            dataKey="bucket_a"
            stackId="3"
            stroke="#82ca9d"
            fill="#82ca9d"
          />
          <Line
            type="monotone"
            dataKey="total"
            stroke="#000000"
            strokeWidth={2}
            dot={false}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Aging;
